// extracted by mini-css-extract-plugin
export default {"iframe-container":"styles_iframe-container__5SR0T"};